import CourseStatusLabel from "@components/CourseStatusLabel";
import React, { useEffect } from "react";
import confetti from "canvas-confetti";
import {
  Box,
  Button,
  Heading,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  Stack,
  Text,
  useColorModeValue,
  useTheme,
} from "@chakra-ui/react";
import { CONFETTI_CONFIG } from "@utils";
import { Link as GatsbyLink } from "gatsby";

type BetasCourseCompletionModalProps = {
  isOpen: boolean;
  onClose: () => void;
  title: string | null;
};

export default function BetasCourseCompletionModal({
  isOpen,
  onClose,
  title,
}: BetasCourseCompletionModalProps) {
  const closeButtonColor = useColorModeValue("white", "current");
  const { zIndices } = useTheme();

  useEffect(() => {
    if (isOpen) {
      confetti({
        ...CONFETTI_CONFIG,
        spread: 360,
        particleCount: 100,
        zIndex: zIndices.popover,
        disableForReducedMotion: true,
      });
    }
  }, [isOpen, zIndices]);

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent aria-label="Course completed!">
        <ModalCloseButton
          // put close button on top of confetti canvas for mobile layout
          zIndex="1"
          color={{
            base: closeButtonColor,
            md: "current",
          }}
        />
        <ModalBody display="flex" flexDir="column" p={6}>
          <Stack spacing="4" fontSize="lg" mb="8">
            <Heading size="lg">
              You did it{" "}
              <span role="img" aria-label="party popper">
                🎉
              </span>
            </Heading>
            <Text>
              Hooray! You’ve completed <strong>{title}</strong>!
            </Text>
            <Text>
              This course is currently in <CourseStatusLabel status="beta" />.
              Content and assessments may change. Come back again when it’s
              officially released!
            </Text>
          </Stack>
          <Box mt="auto" textAlign="right">
            <Button
              as={GatsbyLink}
              to="/dashboard/courses"
              onClick={() => window.gtag?.("event", "dashboard_button_click")}
            >
              View dashboard
            </Button>
          </Box>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
